import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import { useMediaQuery } from '@mui/material';

import { setIsMobileScreen } from './actions';

const DisplaySizeDetector = (props) => {
  const { setIsMobileScreen } = props;

  const isMatchesMobileScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('sm'),
  );

  useEffect(() => {
    window.innerWidth && setIsMobileScreen(isMatchesMobileScreen);
  });

  return null;
};

DisplaySizeDetector.propTypes = {
  setIsMobileScreen: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setIsMobileScreen: (isMobileScreen) =>
    setIsMobileScreen(dispatch, isMobileScreen),
});

export default connect(null, mapDispatchToProps)(DisplaySizeDetector);
